import ReactDOM from "react-dom";
import {useDispatch, useSelector} from "react-redux";
import loadable from "@loadable/component";
import {closeAlert} from "store/actions/alertPopup";
import closeImg from "images/close-btn.png";
import styles from "./index.module.scss";

const popupIndex = [
  {type: "oneButton", component: loadable(() => import("./OneButton"))},
  {type: "twoButton", component: loadable(() => import("./TwoButton"))},
];

const PopupContainer = () => {
  const dispatch = useDispatch();
  const {alertType: popupType, props: popupProps, options: popupOptions} = useSelector(state => state.alertPopup);
  const currentPopup = popupIndex.find(popup => popup.type === popupType);
  const closePopup = () => {
    dispatch(closeAlert());
  };
  const {closeButton, dismissOverlay, invisibleOverlay, defaultPadding, darkmode} = popupOptions;

  return (
    <div className={styles.container}>
      <div
        id="popup_overlay"
        className={`${styles.overlay} ${invisibleOverlay ? styles.invisible : ""}`}
        onClick={() => {
          if (dismissOverlay) closePopup();
        }}
      />
      <div id="popup_scrollable" className={styles.scrollable}>
        <div
          id="popup_contents"
          className={`${styles.contents} ${defaultPadding ? styles.default_padding : ""} ${!darkmode ? styles.light : ""}`}
        >
          {closeButton && <img className={styles.dismissbtn} src={closeImg} alt="popup_dismissbtn" onClick={closePopup} />}
          {currentPopup && currentPopup.component ? <currentPopup.component {...popupProps} /> : null}
        </div>
      </div>
    </div>
  );
};
export default function PopupPortal() {
  const isOpen = useSelector(state => state.alertPopup.isOpen);
  const popup = document.getElementById("alert");
  return isOpen && ReactDOM.createPortal(<PopupContainer />, popup);
}
